import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/element.js'
import request from "@/utils/request";
import '@/assets/icon/iconfont.css'
import VueQuillEditor from 'vue-quill-editor'
// require styles 导入富文本编辑器对应的样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'


import VueWechatTitle from 'vue-wechat-title';
Vue.use(VueWechatTitle);
import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts;

import api from '@/api/index';
Vue.prototype.$api = api;

import Avue from '@smallwei/avue';
import '@smallwei/avue/lib/index.css';
Vue.use(Avue);

Vue.use(VueQuillEditor, /* { default global options } */)

Vue.config.productionTip = false
Vue.prototype.baseURL='http://localhost:8081/'
Vue.prototype.webBaseURL = 'http://localhost:8080/'

// 全局前置守卫
router.beforeEach((to, from, next) => {
    next();
});


// 设置 Vue.prototype.$http 为 axios 的别名：
Vue.prototype.$http = request

new Vue({
    router,
    render: h => h(App),
    //在生命周期函数（钩子）上注册
    beforeCreate() {
        //安装全局事件总线，这里的this是vm
        Vue.prototype.$bus = this;//$bus就是vm
    }
}).$mount('#app')
